import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import galleryOne from "../assets/images/gallery-1.jpeg";
import galleryTwo from "../assets/images/gallery-2.jpg";
import galleryThree from "../assets/images/gallery-3.jpeg";
import galleryFour from "../assets/images/gallery-4.jpg";
import galleryFive from "../assets/images/gallery-5.jpg";
import gallerySix from "../assets/images/gallery-6.jpg";
import gallerySeven from "../assets/images/gallery-7.jpg";
import galleryEight from "../assets/images/gallery-8.jpg";
import galleryNine from "../assets/images/gallery-9.jpg";
import galleryTen from "../assets/images/gallery-10.jpg";
import galleryEleven from "../assets/images/gallery-11.jpg";
import galleryTwelve from "../assets/images/gallery-12.jpg";
import galleryThirtheen from "../assets/images/gallery-13.jpg";
import galleryFourtheen from "../assets/images/gallery-14.jpg";
import galleryFiftheen from "../assets/images/gallery-15.jpg";
import gallerySixtheen from "../assets/images/gallery-16.jpg";
import gallerySeventheen from "../assets/images/gallery-17.jpg";
import galleryEighteen from "../assets/images/gallery-18.jpg";
import galleryNinetheen from "../assets/images/gallery-19.jpg";
import galleryTwenty from "../assets/images/gallery-20.jpg";
import galleryTwentyOne from "../assets/images/gallery-21.jpg";

function Gallery() {
    const images = [
        { id: 1, src: galleryOne, alt: "Cris Gym sala 1" },
        { id: 2, src: galleryTwo, alt: "Cris Gym sala 2" },
        { id: 3, src: galleryThree, alt: "Cris Gym sala 3" },
        { id: 4, src: galleryFour, alt: "Cris Gym sala 4" },
        { id: 5, src: galleryFive, alt: "Cris Gym sala 5" },
        { id: 6, src: gallerySix, alt: "Cris Gym sala 6" },
        { id: 7, src: gallerySeven, alt: "Cris Gym sala 7" },
        { id: 8, src: galleryEight, alt: "Cris Gym sala 8" },
        { id: 9, src: galleryNine, alt: "Cris Gym sala 9" },
        { id: 10, src: galleryTen, alt: "Cris Gym sala 10" },
        { id: 11, src: galleryEleven, alt: "Cris Gym sala 11" },
        { id: 12, src: galleryTwelve, alt: "Cris Gym sala 12" },
        { id: 13, src: galleryThirtheen, alt: "Cris Gym sala 13" },
        { id: 14, src: galleryFourtheen, alt: "Cris Gym sala 14" },
        { id: 15, src: galleryFiftheen, alt: "Cris Gym sala 15" },
        { id: 16, src: gallerySixtheen, alt: "Cris Gym sala 16" },
        { id: 17, src: gallerySeventheen, alt: "Cris Gym sala 17" },
        { id: 18, src: galleryEighteen, alt: "Cris Gym sala 18" },
        { id: 19, src: galleryNinetheen, alt: "Cris Gym sala 19" },
        { id: 20, src: galleryTwenty, alt: "Cris Gym sala 20" },
        { id: 21, src: galleryTwentyOne, alt: "Cris Gym sala 21" },
    ];

    return (
        <main className="gallery-page">
            <Helmet>
                <title>Galerie | Cris Gym Fitness</title>
                <meta
                    name="description"
                    content="Vezi galeria Cris Gym Fitness si descopera un spatiu modern, curat si bine organizat pentru antrenamente eficiente."
                />
            </Helmet>
            <section className="gallery-page-hero">
                <div className="gallery-page-container">
                    <p className="gallery-page-label">Galerie</p>
                    <h1 className="gallery-page-title">
                        Descopera spatiul in care te antrenezi
                    </h1>
                    <p className="gallery-page-subtitle">
                        Un mediu modern, curat si bine organizat, creat pentru antrenamente
                        eficiente si o experienta placuta de fiecare data.
                    </p>
                </div>
            </section>

            <section className="gallery-page-intro">
                <div className="gallery-page-container">
                    <div className="gallery-page-intro-card">
                        <h2>Un spatiu care inspira incredere</h2>
                        <p>
                            La Cris Gym Fitness punem accent pe detalii care conteaza:
                            curatenie, ordine, aparate bine intretinute si o atmosfera in care
                            te poti concentra pe progresul tau.
                        </p>
                    </div>
                </div>
            </section>

            <section className="gallery-page-grid-section">
                <div className="gallery-page-container">
                    <div className="gallery-page-grid">
                        {images.map((image) => (
                            <div key={image.id} className="gallery-page-item">
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    className="gallery-page-image"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="gallery-page-cta">
                <div className="gallery-page-container">
                    <h2 className="gallery-page-cta-title">
                        Vrei sa vezi mai mult?
                    </h2>
                    <p className="gallery-page-cta-text">
                        Contacteaza-ne sau vino direct la sala pentru a descoperi atmosfera
                        si facilitatile de aproape.
                    </p>

                    <div className="gallery-page-cta-buttons">
                        <Link to="/contact" className="gallery-page-btn primary">
                            Contacteaza-ne
                        </Link>
                        <Link to="/abonamente" className="gallery-page-btn secondary">
                            Vezi abonamentele
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Gallery;